export default (set, data) => set(
  () => ({
    promo: {
      ...data
    }
  }),
  false,
  { type: 'promo/removePromoItem', data }
);
